import type {ColSpec} from "~/components/table/MithraTableHeadColumns.tsx";
import {sitColumnLabel} from "../../sitLabels";

export const TARGET_COLUMNS: Array<ColSpec> = [
    {cls: '', txt: sitColumnLabel('title'), columnFieldId: 'title', minWidth: 240},
    {cls: '', txt: sitColumnLabel('owner'), columnFieldId: 'owner__email'},
    // Category / Company are many-to-many, so not orderable.
    {cls: '', txt: sitColumnLabel('category')},
    {cls: '', txt: sitColumnLabel('company')},
    {cls: '', txt: sitColumnLabel('startDate'), columnFieldId: 'start_date'},
    {cls: '', txt: sitColumnLabel('targetYear'), columnFieldId: 'target_year'},
    {cls: '', txt: sitColumnLabel('costSaving'), columnFieldId: 'saving_amount'},
]
